<template>
  <div class="contract-wrap">
    <img src="https://susuanqiniu.knowbox.cn/fe/www-m/contract_01.jpg" />
    <img src="https://susuanqiniu.knowbox.cn/fe/www-m/contract_02.jpg" />
    <img src="https://susuanqiniu.knowbox.cn/fe/www-m/contract_03.jpg" />
    <img src="https://susuanqiniu.knowbox.cn/fe/www-m/contract_04.jpg" />
    <img src="https://susuanqiniu.knowbox.cn/fe/www-m/contract_05.jpg" />
    <img src="https://susuanqiniu.knowbox.cn/fe/www-m/contract_06.jpg" />
    <img src="https://susuanqiniu.knowbox.cn/fe/www-m/contract_07.jpg" />
    <img src="https://susuanqiniu.knowbox.cn/fe/www-m/contract_08.jpg" />
    <img src="https://susuanqiniu.knowbox.cn/fe/www-m/contract_09.jpg" />
    <img src="https://susuanqiniu.knowbox.cn/fe/www-m/contract_10.jpg" />
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Contract extends Vue {}
</script>
<style lang="scss">
.contract-wrap {
  padding-top: 100px;
  img {
    display: block;
    max-width: 750px;
    margin: 0 auto;
  }
}
</style>
